//theme
import { homeColor } from '@/theme/ai';

//components
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';

//styles
import {
  OpsGrid,
  Top100,
  Top100Big,
  Top100Small,
  Top100Copy,
} from './FreightExperts.styles';
import { Container } from '@/components/Grid';

export function FreightExperts() {
  return (
    <Section id="operators">
      <Container>
        <OpsGrid>
          <div>
            <Kicker color={homeColor.amber}>
              <KickerDot color={homeColor.amber} />
              When you need humans
            </Kicker>
            <SectionTitle>
              Freight Experts, <Grad>on call.</Grad>
            </SectionTitle>
            <SectionLede>
              Every other AI automates the easy part and hands the hard part
              back to you. Our Freight Experts take on the hard part. You get
              the results. Nothing else.
            </SectionLede>
          </div>
          <Top100>
            <div>
              <Top100Big>Top 100</Top100Big>
              <Top100Small>
                Transport Topics
                <br />
                Freight Brokerage Firm
              </Top100Small>
            </div>
            <Top100Copy>
              <b>Our Freight Experts move real freight every day.</b> They bring
              230k+ carrier relationships and more than a decade of industry
              expertise to finish what software starts.
            </Top100Copy>
          </Top100>
        </OpsGrid>
      </Container>
    </Section>
  );
}
